import AuthMixin from '@/components/mixins/auth-mixin'
import CommonOptionsMixin from '@/components/mixins/common-options-mixin'
import OnEnterMixin from '@/components/mixins/onenter-mixin'
import MediaMenu from '@/components/common/media-menu/media-menu-tmpl'
import TagSlider from '@/components/common/tag-slider/tag-slider-tmpl'
import PopIdsSlider from '@/components/common/pop-identifier-slider/pop-identifier-slider-tmpl'
import EventBus from '@/components/mixins/event-bus-mixin'
import { mapState as piniaMapState } from 'pinia'
import { useFileUploaderStore } from '@/pinia/stores/file-upload/fileUploaderStore'
import { useCognitoAuthStore } from '@base-shared/stores/cognito-auth'
import _ from 'lodash'
import CONST from '@/globals/constants'

export default {
  name: 'mediaList',
  inject: [
    '$currentUser',
    '$utils',
    '$api',
    '$apiError',
    '$dataStore',
    '$filtersRepository'
  ],
  components: {
    MediaMenu,
    TagSlider,
    PopIdsSlider
  },
  props: {
    accessorComponentProp: {
      type: String,
      default () { return 'createTemplate' }
    },
    isMediaListVisibleProp: {
      type: Boolean,
      default () { return false }
    },
    defaultMediaTypeFilterProp: {
      type: String,
      default () { return 'img' }
    },
    mediaSelectionProp: {
      type: Array,
      default () { return [] }
    },
    mediaTypeOptionsProp: {
      type: Array,
      default () { return ['img', 'video'] }
    },
    mediaItemToHideProp: {
      type: Array,
      default () { return [] }
    },
    showProjectFilterOptionProp: {
      type: Boolean,
      default () { return false }
    },
    additionalMediaFilterTypeProp: {
      type: Array,
      default () { return [] }
    },
    isMultipleUploadProp: {
      type: Boolean,
      default () { return false }
    },
    tagSliderledTagItemProp: {
      type: String,
      default () { return '' }
    },
    forSmartAddsProp: {
      type: Boolean,
      default () { return false }
    },
    playerFeaturesProp: {
      type: Array,
      default () { return [] }
    },
    isActive: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...piniaMapState(useFileUploaderStore, {
      fileUploaderState: 'uploadedFiles'
    })
  },
  watch: {
    fileUploaderState (newVal) {
      if (newVal.prevAction === 'processNewFilesWithInstance') {
        const data = []
        newVal.files.forEach(file => {
          if (file._edit && file._edit.uploadRequests.createMediaInstanceResponseData) data.push(file._edit.uploadRequests.createMediaInstanceResponseData)
        })

        if ([this.accessorComponentsOptions.SCHEDULE_EVENT_ITEM, this.accessorComponentsOptions.CREATE_PROJECT_AUDIO].indexOf(this.accessorComponent) >= 0) {
          this.handleMediaFileUploadChange({ action: 'UPLOADED_MEDIA_FILES', payload: { data: [] } })
        } else {
          this.handleMediaFileUploadChange({ action: 'UPLOADED_MEDIA_FILES', payload: { data } })
        }
      }
    },
    isMediaListVisibleProp (newIsMediaListVisibleProp) {
      this.handleMediaListVisible(newIsMediaListVisibleProp)
    },
    mediaItemToHideProp: {
      handler (newMediaItemToHideProp) {
        this.mediaItemToHide = newMediaItemToHideProp
      },
      deep: true
    },
    additionalMediaFilterTypeProp: {
      handler (newVal) {
        this.additionalMediaFilterType = newVal
      },
      deep: true
    },
    tagSliderledTagItemProp (newVal) {
      this.tagSliderledTagItem = newVal
    },
    playerFeaturesProp: {
      handler (newVal) {
        this.playerFeatures = newVal
      },
      deep: true
    },
    searchTextVal () {
      this.debouncedSearch()
    },
    mediaSelectionProp: {
      immediate: true,
      deep: true,
      handler (val) {
        this.mediaSelection = !_.isEmpty(val) ? val : []
      }
    }
  },
  setup () {
    const fileUploaderStore = useFileUploaderStore();

    return { fileUploaderStore }
  },
  data () {
    return {
      CONST,
      mediaTypes: { ...this.$utils.options.mediaFileType },
      enableMediaUpload: false,
      accessorComponent: this.accessorComponentProp,
      accessorComponentsOptions: {
        CREATE_PROJECT_TEMPLATES: 'createTemplate',
        EDIT_PROJECT_TEMPLATE: 'editProjectTemplate',
        SCHEDULE_EVENT_ITEM: 'scheduleEventItem',
        CREATE_PROJECT_AUDIO: 'createProjectAudio'
      },
      error: '',
      fetchingMediaSelectionDetails: false,
      showSearchInput: false,
      searchTextVal: '',
      mediaFilter: {
        isFilterChange: false,
        mediaTypeOptions: {}, // set onMount
        selectedMediaType: this.defaultMediaTypeFilterProp
      },
      fileUploadAcceptedFileType: this.mediaTypeOptionsProp,
      originalPresentMediaListBeforeTheSearch: null,
      mediaList: {
        batchHistory: [],
        itemsToShow: [],
        nextFetch: {
          moreItems: false,
          exclusiveStartResourceId: null
        }
      },
      mediaOrientation: 'horizontal',
      mediaSelection: this.mediaSelectionProp,
      previousMediaItemSelected: {
        mediaItem: {},
        mediaItemPosition: 0
      },
      previousKeyPressedInMediaSelection: null,
      userSchedules: [],
      playVideo: {
        dialog: false,
        videopreviews: []
      },
      isIEBrowser: false,
      isChromeBrowser: false,
      newMediaUploadFileList: [],
      mediaItemToHide: this.mediaItemToHideProp,
      additionalMediaFilterType: this.additionalMediaFilterTypeProp,
      showImageFilterOption: true,
      showProjectFilterOption: this.showProjectFilterOptionProp,
      showVideoFilterOption: true,
      showAudioFilterOption: false,
      isMultipleUpload: this.isMultipleUploadProp,
      selectedTagsFromSlider: [],
      selectedPopIdsFromSlider: [],
      refreshTagSlider: { ref: null, refresh: false },
      tagSliderledTagItem: this.tagSliderledTagItemProp,
      asAudioPicker: false,
      showPopIdsSliderFilter: this.$currentUser.hasFeatureProofOfPlayExtended(),
      isForSmartAddsPreviousFlag: false,
      playerFeatures: this.playerFeaturesProp,
      multiSelect: false
    }
  },
  mixins: [AuthMixin, CommonOptionsMixin, OnEnterMixin],
  methods: {
    debouncedSearch: _.debounce(function (query) {
      this.handlePreFlightSearchFromPresentData()

      window.setTimeout(() => {
        this.getMediaList({
          resetMediaList: false,
          mediaFilterTextInputConfirm: true,
          hideLoader: true
        })
      }, 500)
    }, 300),
    emitEventToParent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('media-list-change', { action, payload: { data } })
      }
    },
    setDefaultData () {
      const mediaFilter = this.$utils.clone(this.mediaFilter)

      // Project Template
      if ([this.accessorComponentsOptions.EDIT_PROJECT_TEMPLATE, this.accessorComponentsOptions.CREATE_PROJECT_TEMPLATES].includes(this.accessorComponent)) {
        mediaFilter.selectedMediaType = ['all']
        this.showVideoFilterOption = this.mediaTypeOptionsProp.indexOf('video') !== -1

        // Media video type visibility
        if (!this.showVideoFilterOption) {
          this.mediaItemToHide.push('hideAllVideoType')
        } else {
          this.mediaItemToHide = this.$utils.clone(this.mediaItemToHide).filter((t) => { return t !== 'hideAllVideoType' })
        }

        this.showPopIdsSliderFilter = false
        this.multiSelect = false
      }

      // Schedule Media Event
      if (this.accessorComponent === this.accessorComponentsOptions.SCHEDULE_EVENT_ITEM) {
        mediaFilter.selectedMediaType = ['all']
        this.showAudioFilterOption = false

        if (this.$currentUser.hasGroupExtended()) {
          this.showAudioFilterOption = true
        }

        if (this.$currentUser.hasGroupExtended() && (this.$currentUser.hasGroupUserAdmin() || this.$currentUser.hasGroupUserCreate() || this.$currentUser.hasGroupUserCreateLock())) {
          this.isCreateProjectAudioButtonVisible = true
        }

        // Hide auto for smart adds
        if (this.forSmartAddsProp) {
          this.showAudioFilterOption = false
          this.isForSmartAddsPreviousFlag = true
        } else {
          this.isForSmartAddsPreviousFlag = false
        }

        // Update file upload accepted files
        if (this.showAudioFilterOption && this.fileUploadAcceptedFileType.indexOf(this.mediaTypes.audio) < 0) {
          const fileUploadAcceptedFileType = this.$utils.clone(this.fileUploadAcceptedFileType)
          fileUploadAcceptedFileType.push(this.mediaTypes.audio)
          this.fileUploadAcceptedFileType = fileUploadAcceptedFileType
        }

        this.multiSelect = true
      }

      // Project Audio
      if (this.accessorComponent === this.accessorComponentsOptions.CREATE_PROJECT_AUDIO) {
        mediaFilter.selectedMediaType = [this.mediaTypes.audio]
        this.showImageFilterOption = false
        this.showProjectFilterOption = false
        this.showVideoFilterOption = false
        this.showPopIdsSliderFilter = false
        this.multiSelect = false
      }

      this.mediaFilter = mediaFilter
      this.setAsAudioPicker()
      this.refreshTagSlider = { ref: this.$utils.generateUniqueID(), refresh: true }
    },
    setMediaList (mediaList = {}) {
      this.mediaList = this.filterMediaList(mediaList)
    },
    handlePreFlightSearchFromPresentData () {
      const dataSource = this.originalPresentMediaListBeforeTheSearch ? this.$utils.clone(this.originalPresentMediaListBeforeTheSearch.batchHistory) : []
      const mediaTypeSource = this.mediaFilter.selectedMediaType.filter(item => item !== 'all')
      const searchText = this.searchTextVal.trim()
      const searchByName = (searchText.length > 0 && mediaTypeSource.length === 0 && this.selectedTagsFromSlider.length === 0)
      const searcyByNameAndType = (searchText.length > 0 && mediaTypeSource.length > 0 && this.selectedTagsFromSlider.length === 0)
      const searcyByNameAndTags = (searchText.length > 0 && mediaTypeSource.length === 0 && this.selectedTagsFromSlider.length > 0)
      const searchByNameAndTypeAndTags = (searchText.length > 0 && mediaTypeSource.length > 0 && this.selectedTagsFromSlider.length > 0)
      const searchByFileType = (searchText.length === 0 && mediaTypeSource.length > 0 && this.selectedTagsFromSlider.length === 0)
      const searchByFileTypeAndTags = (searchText.length === 0 && mediaTypeSource.length > 0 && this.selectedTagsFromSlider.length > 0)
      const searchByTags = (searchText.length === 0 && mediaTypeSource.length === 0 && this.selectedTagsFromSlider.length > 0)
      const searchByPopIds = (!searchByName && !searchByFileType && !searchByTags && this.selectedPopIdsFromSlider.length)
      const searcyByNameAndPopIds = (searchByName && !searchByFileType && !searchByTags && this.selectedPopIdsFromSlider.length)
      const searchByNameAndTagsAndPopIds = (searchByName && searchByTags && this.selectedPopIdsFromSlider.length)
      const searchByTagsAndPopIds = (!searchByName && !searchByFileType && searchByTags && this.selectedPopIdsFromSlider.length)
      const preflightSearchResults = []

      for (const mediaBatch of dataSource) {
        for (const mediaBatchIndx in mediaBatch) {
          const mediaItem = mediaBatch[mediaBatchIndx]
          const mediaIncludesName = mediaItem.name.toLowerCase().includes(searchText.toLowerCase())
          const mediaIncludesFileType = (mediaTypeSource.indexOf(mediaItem.type) >= 0)
          let mediaIncludesTag = false
          const selectedTags = this.selectedTagsFromSlider.join(',').toLowerCase()
          const mediaIncludesPopId = false

          // Check tags
          if (!mediaItem.tags) mediaItem.tags = []
          const isMultipleTags = this.selectedTagsFromSlider.length > 1

          if (isMultipleTags) {
            const selectedTagsSort = this.$utils.clone(this.selectedTagsFromSlider).sort().join(',').toLowerCase()
            const mediaTagsSort = this.$utils.clone(mediaItem.tags).sort().join(',').toLowerCase()
            if (selectedTagsSort === mediaTagsSort) {
              mediaIncludesTag = true
            }

            mediaIncludesTag = this.selectedTagsFromSlider.every((selectedTag) => { return mediaItem.tags.includes(selectedTag) })
          } else {
            for (const indx in mediaItem.tags) {
              if (selectedTags === mediaItem.tags[indx].toLowerCase()) {
                mediaIncludesTag = true
                break
              }
            }
          }

          let addToResult = false

          if (searchByName && mediaIncludesName) { // Search by name
            addToResult = true
          } else if (searchByFileType && mediaIncludesFileType) { // Search by type
            addToResult = true
          } else if (searchByTags && mediaIncludesTag) {
            addToResult = true
          } else if (searcyByNameAndType && (mediaIncludesName && mediaIncludesFileType)) {
            addToResult = true
          } else if (searcyByNameAndTags && (mediaIncludesName && mediaIncludesTag)) {
            addToResult = true
          } else if (searchByFileTypeAndTags && (mediaIncludesFileType && mediaIncludesTag)) {
            addToResult = true
          } else if (searchByNameAndTypeAndTags && (mediaIncludesName && mediaIncludesFileType && mediaIncludesTag)) {
            addToResult = true
          } else if (searchByPopIds && mediaIncludesPopId) {
            addToResult = true
          } else if (searcyByNameAndPopIds && (mediaIncludesName && mediaIncludesPopId)) {
            addToResult = true
          } else if (searchByNameAndTagsAndPopIds && (mediaIncludesName && mediaIncludesTag && mediaIncludesPopId)) {
            addToResult = true
          } else if (searchByTagsAndPopIds && (mediaIncludesTag && mediaIncludesPopId)) {
            addToResult = true
          }

          if (addToResult) {
            preflightSearchResults.push(mediaItem)
          }
        }
      }

      const mediaList = this.$utils.clone(this.mediaList)
      mediaList.batchHistory = [preflightSearchResults]
      mediaList.itemsToShow = preflightSearchResults
      mediaList.nextFetch.moreItems = false
      mediaList.nextFetch.exclusiveStartResourceId = null
      this.setMediaList(mediaList)
    },
    handleMediaListVisible (newIsMediaListVisibleProp) {
      if (newIsMediaListVisibleProp) {
        // Set Orientation
        this.mediaOrientation = this.$dataStore.getMediaOrientation()
        if ([this.accessorComponentsOptions.EDIT_PROJECT_TEMPLATE, this.accessorComponentsOptions.CREATE_PROJECT_TEMPLATES].includes(this.accessorComponent)) {
          this.mediaOrientation = this.$filtersRepository.findOrientation() ?? CONST.ORIENTATION_VALUE_HORIZONTAL
        }

        this.setDefaultData()
        this.getMediaList({
          callback: () => { this.$utils.mainLoader(false) }
        })

        this.updateFileUploaderConfig({ showMediaListModal: true })
      } else {
        this.updateFileUploaderConfig({ hideMediaListModal: true })
      }
    },
    updateFileUploaderConfig (params) {
      const newFileUploaderConfig = {
        setDropzoneInMediaListModal: true,
        unsetDropzoneInMediaListModal: false,
        triggerClickDropzone: false,
        acceptedFileTypes: this.fileUploadAcceptedFileType
      }

      // Set Target component and dropzone
      if (this.accessorComponent === this.accessorComponentsOptions.CREATE_PROJECT_TEMPLATES) { // Project templates
        newFileUploaderConfig.targetComponent = 'projectTemplatesPage'
      } else if (this.accessorComponent === this.accessorComponentsOptions.EDIT_PROJECT_TEMPLATE) { // Create/Edit Project
        newFileUploaderConfig.targetComponent = 'editProjectTemplatePage'

        // Do not accept video if video filter is disabled
        if (!this.showVideoFilterOption) {
          newFileUploaderConfig.acceptedFileTypes = this.fileUploadAcceptedFileType.filter((type) => type !== 'video')
        }

        // Add elementi project in accepted files
        if (this.$currentUser.hasGroupEnterprise() && this.$currentUser.hasFeatureElementiMedia()) newFileUploaderConfig.acceptedFileTypes.push('7z')
      } else if (this.accessorComponent === this.accessorComponentsOptions.CREATE_PROJECT_AUDIO) { // Audio Page
        newFileUploaderConfig.targetComponent = 'createProjectAudioPage'
      } else if (this.accessorComponent === this.accessorComponentsOptions.SCHEDULE_EVENT_ITEM) { // Schedule Page with selected player
        newFileUploaderConfig.targetComponent = 'schedulePagePlayerSelected'
        newFileUploaderConfig.targetDropzoneId = this.forSmartAddsProp ? 'fileUploaderSmartAdds' : 'fileUploaderRegularMedia'
        if (Array.isArray(newFileUploaderConfig.acceptedFileTypes) && newFileUploaderConfig.acceptedFileTypes.indexOf('all') < 0) newFileUploaderConfig.acceptedFileTypes.push('all')
        newFileUploaderConfig.targetPlayerId = $('#scheduleItemFullDetails').attr('class').toString().match(/(\bplayerId-\S+\b)/ig)[0].substring(9)
      }

      // Set value depends on action
      if (params.hideMediaListModal) {
        newFileUploaderConfig.triggerClickDropzone = false
        newFileUploaderConfig.setDropzoneInMediaListModal = false
        newFileUploaderConfig.unsetDropzoneInMediaListModal = true

        if (this.accessorComponent === this.accessorComponentsOptions.SCHEDULE_EVENT_ITEM) {
          newFileUploaderConfig.targetDropzoneId = this.isForSmartAddsPreviousFlag ? 'fileUploaderSmartAdds' : 'fileUploaderRegularMedia'
        }
      } else if (params.fileUploadCardClick) {
        newFileUploaderConfig.triggerClickDropzone = true
      }

      this.fileUploaderStore.setUploaderConfig(newFileUploaderConfig)
    },
    setAsAudioPicker () {
      this.asAudioPicker = (this.accessorComponent === this.accessorComponentsOptions.CREATE_PROJECT_AUDIO) || (this.mediaFilter.selectedMediaType.indexOf(this.mediaTypes.audio) >= 0)
    },
    handleTagSliderChange ($event) {
      if ($event.action === CONST.EMIT_EVENT_NEW_SELECTED_TAGS_FROM_SLIDER) {
        this.selectedTagsFromSlider = $event.payload.data
        this.getMediaList()
      }

      if ($event.action === CONST.EMIT_EVENT_ALL_TAG_SELECTED_FROM_SLIDER) {
        this.selectedTagsFromSlider = []
        this.getMediaList()
      }
    },
    handlePopIdsSliderChange ($event) {
      if ($event.action === CONST.EMIT_EVENT_NEW_SELECTED_POP_ID_FROM_SLIDER) {
        this.selectedPopIdsFromSlider = $event.payload.data
        this.getMediaList()
      }

      if ($event.action === CONST.EMIT_EVENT_ALL_SELECTED_POPID_FROM_SLIDER || $event.action === CONST.EMIT_EVENT_DELETED_POPID_FROM_SLIDER) {
        this.selectedPopIdsFromSlider = []
        this.getMediaList()
      }

      if ($event.action === CONST.EMIT_EVENT_LIST_OF_POP_IDS_FROM_SLIDER) {
        this.selectedPopIdsFromSlider = []
        this.getMediaList()
      }
    },
    /**
         * This will filter media list object data
         * @param {Object} mediaListSrc - mediaList Source
         */
    filterMediaList (mediaListSrc) {
      const mediaList = this.$utils.clone(mediaListSrc)
      const mediaSelection = this.$utils.clone(this.mediaSelection)

      for (const mediaItem of mediaList.itemsToShow) {
        // Set _edit prop default values
        if (!mediaItem._edit) {
          mediaItem._edit = {
            selected: false,
            uid: mediaItem.resourceId,
            iFrameStatus: 'default',
            fetchingIframeContent: false,
            iframeContent: null,
            preview: mediaItem.preview
          }
        } else {
          mediaItem._edit.selected = false
        }

        // Set media item selection status based from media selection data
        for (const medSelIndx in mediaSelection) {
          if (mediaItem.resourceId === mediaSelection[medSelIndx].resourceId) {
            mediaItem._edit.selected = true
          }
        }

        if (this.mediaItemToHide.indexOf(mediaItem.resourceId) >= 0 || (this.mediaItemToHide.indexOf('hideAllVideoType') >= 0 && mediaItem.type === 'video')) {
          mediaItem._edit.notVisible = true
        }
      }
      return mediaList
    },
    /**
      * Get media list from API
      * @param {Object} getListParams - params for requests
    */
    getMediaList (getListParams = {}) {
      let params = {
        dir: this.mediaOrientation,
        max: 100,
        validity: 1,
        width: 424,
        use_qsa: 1
      }

      // Set Media Search text
      if (this.searchTextVal.trim()) {
        params.search = this.searchTextVal.trim()
      }

      // Merge additional request params
      if (typeof (getListParams.additionalParams) === 'object') {
        params = { ...params, ...getListParams.additionalParams }
      }

      // Set tags and led params
      const selectedTagsFromSlider = this.$dataStore.getStore().selectedTagsFromSlider ? this.$dataStore.getStore().selectedTagsFromSlider : {}
      const selectedTagsForMediaListModal = (selectedTagsFromSlider && selectedTagsFromSlider.mediaListInModal) ? selectedTagsFromSlider.mediaListInModal : []
      if (selectedTagsForMediaListModal.length) {
        const selectedTagsFromSlider = this.$utils.clone(selectedTagsForMediaListModal)
        const getLEDTagIndx = this.$utils.clone(selectedTagsFromSlider).findIndex((tag) => { return tag.includes('LED:') })

        if (getLEDTagIndx >= 0) {
          params.led = this.$utils.parseLedTag(selectedTagsFromSlider[getLEDTagIndx]).dimension
          selectedTagsFromSlider.splice(getLEDTagIndx, 1)
          params.tags = JSON.stringify(selectedTagsFromSlider)
        } else {
          params.tags = JSON.stringify(selectedTagsFromSlider)
        }
      }

      // Set tags and led params
      const selectedPopIdsFromSlider = this.$dataStore.getStore().selectedPopIdsFromSlider ? this.$dataStore.getStore().selectedPopIdsFromSlider : {}
      const selectedPopIdsForMediaListModal = (selectedPopIdsFromSlider && selectedPopIdsFromSlider.mediaListInModal) ? selectedPopIdsFromSlider.mediaListInModal : []

      if ([this.accessorComponentsOptions.EDIT_PROJECT_TEMPLATE, this.accessorComponentsOptions.CREATE_PROJECT_TEMPLATES].indexOf(this.accessorComponent) < 0 && selectedPopIdsForMediaListModal.length) {
        const selectedTagsFromSlider = this.$utils.clone(selectedPopIdsForMediaListModal)
        params.popIds = JSON.stringify(selectedTagsFromSlider)
      }

      // Reset the media List
      if ((_.isUndefined(getListParams.resetMediaList)) || (_.isBoolean(getListParams.resetMediaList) && getListParams.resetMediaList === true)) {
        this.resetMediaList()
      }

      let mediaTypeParams = this.$utils.clone(this.mediaFilter.selectedMediaType)

      // Adjust media types params and max value for schedule event
      if (this.accessorComponent === this.accessorComponentsOptions.SCHEDULE_EVENT_ITEM) {
        const hasAllType = mediaTypeParams.indexOf('all') >= 0
        // Default types
        if (hasAllType) {
          mediaTypeParams = []
          mediaTypeParams.push(this.mediaTypes.img)
          mediaTypeParams.push(this.mediaTypes.video)
          mediaTypeParams.push(this.mediaTypes.project)
          mediaTypeParams.push(this.mediaTypes.audio)
          mediaTypeParams.push(this.mediaTypes.audio)
          mediaTypeParams.push(this.mediaTypes.audioPlaylist)

          // Add elementi
          if (this.additionalMediaFilterType.includes(this.mediaTypes.elementi)) {
            mediaTypeParams.push(this.mediaTypes.elementi)
          }
        }

        // Add audio-playlist together with audio type
        if (!hasAllType && mediaTypeParams.includes(this.mediaTypes.audio)) {
          mediaTypeParams.push(this.mediaTypes.audioPlaylist)
        }

        // Add elementi together with project type
        if (!hasAllType && (mediaTypeParams.includes(this.mediaTypes.project)) && (this.additionalMediaFilterType.includes(this.mediaTypes.elementi))) {
          mediaTypeParams.push(this.mediaTypes.elementi)
        }

        // Adjust max params
        if (this.mediaItemToHide.length > 0) {
          params.max = params.max + this.mediaItemToHide.length
        }
      }

      // Adjust media types params for project template
      if ([this.accessorComponentsOptions.EDIT_PROJECT_TEMPLATE, this.accessorComponentsOptions.CREATE_PROJECT_TEMPLATES].includes(this.accessorComponent)) {
        if (mediaTypeParams.includes('all')) {
          mediaTypeParams = []
          mediaTypeParams.push(this.mediaTypes.img)
          mediaTypeParams.push(this.mediaTypes.video)

          if (this.showProjectFilterOptionProp) mediaTypeParams.push(this.mediaTypes.elementi)
        }

        // Change project type to elementi
        if (this.showProjectFilterOptionProp && mediaTypeParams.includes(this.mediaTypes.project)) {
          mediaTypeParams[mediaTypeParams.indexOf(this.mediaTypes.project)] = this.mediaTypes.elementi
        }
      }

      // Set type params
      if (Array.isArray(mediaTypeParams) && !mediaTypeParams.includes('all')) {
        params.type = mediaTypeParams.sort().join(',')
      }

      // Set Features
      if (Array.isArray(this.playerFeatures)) {
        params.features = this.playerFeatures.sort().join(',')
      }

      const mediaList = this.$utils.clone(this.mediaList)
      const apiRequest = () => {
        this.error = ''

        if (!getListParams.hideLoader) {
          this.$utils.mainLoader(true)
        }
        const sessionStage = useCognitoAuthStore().sessionStage ?? CONFIG.GLOBAL_STAGE;
        const APIUrl = this.$utils.getStageAPIUrl(sessionStage)
        this.$api.get(`${APIUrl}/media`, { params })
          .then(response => {
            const newMediaBatch = response.data.media

            // Process newMediaBatch
            if (newMediaBatch.length > 0) {
              // Put the newMediaBatch into batch history
              mediaList.batchHistory.push(newMediaBatch)

              // Add each new media item into itemsToShow
              for (const newMedia of newMediaBatch) {
                if (!mediaList.itemsToShow.find(item => item.resourceId === newMedia.resourceId)) {
                  mediaList.itemsToShow.push(newMedia)
                }
              }

              // Check the last media item if there's moreItems property
              const lastMediaItem = newMediaBatch[newMediaBatch.length - 1]
              if (lastMediaItem.moreItems) {
                mediaList.nextFetch.moreItems = true
                mediaList.nextFetch.exclusiveStartResourceId = lastMediaItem.resourceId
              } else {
                mediaList.nextFetch.moreItems = false
                mediaList.nextFetch.exclusiveStartResourceId = null
              }
              this.setMediaList(mediaList)

              // Keep as original list
              if (getListParams.mounted) {
                this.originalPresentMediaListBeforeTheSearch = this.mediaList
              }
            }

            // Disable or Enable Upload
            let enableMediaUploadVal = false
            // User Storage contract layer
            if (response.data.upload) {
              if (response.data.upload) {
                enableMediaUploadVal = true
              }
            } else {
              enableMediaUploadVal = true
            }

            // User Rights contract layer
            if (!this.$currentUser.getRights().userCreate.uploadMedia) {
              enableMediaUploadVal = false
            }
            this.enableMediaUpload = enableMediaUploadVal

            // Auto Adjust content
            this.$utils.updatePageComponentStyle({ name: 'mediaListInModal' })

            if (typeof (getListParams.callback) === 'function') {
              getListParams.callback()
            } else {
              this.$utils.mainLoader(false)
            }
          })
          .catch((error) => {
            this.error = error.message
            this.$utils.mainLoader(false)
            this.$apiError.handleAPIRequestError(error, { originalRequest: () => { apiRequest() }, showDialogNotification: true })
          })
      }
      apiRequest()
    },
    processMediaSelection (event = {}, currentMediaItem = {}, currentMediaItemPosition = 0) {
      const isCTRLKeyPressed = this.multiSelect ? event.ctrlKey : false
      const isShiftKeyPressed = this.multiSelect ? event.shiftKey : false
      const mediaList = this.mediaList
      let mediaSelection = this.mediaSelection

      // Validate target media if currently selected
      const isMediaItemExistInMediaSelectionList = { exist: false, currentMediaItemPosition: 0 }
      for (const position in mediaSelection) {
        if (mediaSelection[position].resourceId === currentMediaItem.resourceId) {
          isMediaItemExistInMediaSelectionList.exist = true
          isMediaItemExistInMediaSelectionList.currentMediaItemPosition = position
          break
        }
      }

      // Set target media as last position clicked
      const setAsLastMediaItemClicked = () => {
        this.previousMediaItemSelected = {
          mediaItem: currentMediaItem,
          mediaItemPosition: currentMediaItemPosition
        }
      }

      // Single selection, No key pressed
      if (!isCTRLKeyPressed && !isShiftKeyPressed) {
        mediaSelection = []

        if (['shift', 'ctrl'].includes(this.previousKeyPressedInMediaSelection)) {
          mediaSelection.push(currentMediaItem)
        } else {
          if (!isMediaItemExistInMediaSelectionList.exist) {
            mediaSelection.push(currentMediaItem)
          }
        }

        setAsLastMediaItemClicked() // Keep as last media item clicked
        this.previousKeyPressedInMediaSelection = null // Keep as previous key pressed
      }

      // Multiple selection with CTRL key pressed
      if (isCTRLKeyPressed) {
        if (!isMediaItemExistInMediaSelectionList.exist) {
          mediaSelection.push(currentMediaItem)
        } else {
          mediaSelection.splice(isMediaItemExistInMediaSelectionList.currentMediaItemPosition, 1)
        }

        setAsLastMediaItemClicked() // Keep as last media item clicked
        this.previousKeyPressedInMediaSelection = 'ctrl' // Keep as previous key pressed
      }

      // Multiple selection with SHIFT Key Pressed
      if (isShiftKeyPressed) {
        const { mediaItemPosition } = this.previousMediaItemSelected
        let startPosition = 0
        let endPosition = 0
        mediaSelection = []

        if (mediaItemPosition < currentMediaItemPosition) {
          startPosition = mediaItemPosition
          endPosition = currentMediaItemPosition
        } else {
          startPosition = currentMediaItemPosition
          endPosition = mediaItemPosition
        }

        for (let i = startPosition; i <= endPosition; i++) {
          mediaSelection.push(this.mediaList.itemsToShow[i])
        }

        this.previousKeyPressedInMediaSelection = 'shift' // Keep as previous key pressed
      }

      this.mediaSelection = mediaSelection
      this.setMediaList(mediaList)

      if (!this.multiSelect && this.mediaSelection.length) {
        this.sendMediaSelectionToParent(this.mediaSelection)
      }
    },
    handleMediaCardClick (event = {}, media = {}, position = 0) {
      if (media.disabled) return

      // Show warning dialog if there's an unsaved data
      const hasUnsavedMediaPropertiesData = _.isObject(this.$refs.mediaProperties) && this.$refs.mediaProperties._data.editedMediaProperties.length
      if (hasUnsavedMediaPropertiesData) {
        EventBus.$emit('SHOW_CUSTOM_NOTIFICATION', {
          type: 'warning',
          title: this.$t('confirm.unsavedChanges'),
          alert: {
            message: this.$t('texts.youHaveUnsavedChanges')
          },
          confirmButtonText: this.$t('buttons.continueWithoutSaving'),
          callbacks: {
            eventOKButtonClick: () => {
              this.processMediaSelection(event, media, position)
            }
          }
        })
      } else {
        this.processMediaSelection(event, media, position)
      }
    },
    resetMediaSelection (emitEventToParent = false) {
      this.mediaSelection = []
      this.setMediaList(this.mediaList)
      this.previousKeyPressedInMediaSelection = null

      if (emitEventToParent) {
        this.emitEventToParent('HIDE_MEDIA_LIST_DIALOG', this.mediaSelection)
      }
    },
    sendMediaSelectionToParent (mediaSelection = []) {
      this.emitEventToParent('MEDIA_SELECTION', mediaSelection)
    },
    resetMediaList () {
      this.setMediaList({
        batchHistory: [],
        itemsToShow: [],
        nextFetch: {
          moreItems: false,
          exclusiveStartResourceId: null
        }
      })
    },
    mediaTypeFilterOnChange (mediaType = '') {
      const mediaFilter = this.$utils.clone(this.mediaFilter)

      if (!mediaFilter.selectedMediaType.includes(mediaType)) {
        mediaFilter.selectedMediaType = [mediaType]
      } else {
        mediaFilter.selectedMediaType = ['all']
      }

      this.mediaFilter = mediaFilter
      this.setAsAudioPicker()
      this.resetMediaSelection()
      this.getMediaList()
    },
    mediaFilterShowTextInput () {
      this.showSearchInput = true

      this.$nextTick(_ => {
        this.$refs.searchTextInput.$refs.input.focus()
      })
    },
    mediaFilterTextInputConfirm () {
      if (!this.searchTextVal.trim()) {
        this.showSearchInput = false
      }
    },
    handleWhiteBackgroundOnClick (event) {
      if (event.srcElement && $(event.srcElement).hasClass('clear-media-selection-if-clicked')) {
        this.clearMediaSelection()
      }
    },
    /**
      * Handle Play video preview in the pop-up
      * @param {Array} videopreviews - list of video previous
    */
    handleVideoPlayIconClick (videopreviews) {
      const playVideo = this.$utils.clone(this.playVideo)

      playVideo.dialog = true
      playVideo.videopreviews = videopreviews

      this.playVideo = playVideo
    },
    /**
      * Handle Media Orientation Option click
      * @param {String} orientation
    */
    handleProjectOrientationClick (orientation) {
      this.mediaOrientation = orientation
      this.$dataStore.setMediaOrientation(orientation)
      let additionalParams = { max: 9, width: 396 }

      if (orientation === 'vertical') {
        additionalParams = { max: 10, width: 264 }
      }

      this.getMediaList({
        additionalParams
      })
    },
    /**
      * Cleanup media upload file list
      * - Remove those items with error status so that it will not be resend on the next cycle
    */
    cleanupNewMediaUploadFileList () {
      let newMediaUploadFileList = this.$utils.clone(this.newMediaUploadFileList)

      newMediaUploadFileList = newMediaUploadFileList.filter((item) => {
        return item._edit.requests.createMediaStatus !== 'error' || item._edit.requests.createMediaStatusCode === 401
      })

      this.newMediaUploadFileList = newMediaUploadFileList
    },
    handleMediaFileUploadChange ($event) {
      if ($event.action === 'UPLOADED_MEDIA_FILES') {
        const newMediaFiles = $event.payload.data
        this.sendMediaSelectionToParent(newMediaFiles)
      }
    },
    /**
         * Workaround for Chrome to show/hide iFrame because of the drag and drop issue
         * @param {String} action - action type
         */
    handleProjectIFrameVisibility (action) {
      if (this.isChromeBrowser) {
        if (action === 'hideIFrame' && this.isMediaListVisibleProp) {
          $('.project-frame-content').addClass('hide-project-iframe')
        } else {
          $('.project-frame-content').removeClass('hide-project-iframe')
        }
      }
    },
    handleSVGMessage (event) {
      // Make sure event.origin is from the app to prevent accepting message out of nowhere and event.data is an object

      const sessionStage = this.cognitoAuthStore.sessionStage ?? CONFIG.GLOBAL_STAGE;
      const APIUrl = this.$utils.getStageAPIUrl(sessionStage)
      const apiOrigin = (new URL(APIUrl)).origin
      if ((event.origin !== apiOrigin) || (!_.isPlainObject(event.data))) return

      if (event.data && event.data.loaded && event.data.uri) $(`.audio-status-frame[src="${event.data.uri}"]`).addClass('iframe-loaded')

      if (event.data && event.data.status && event.data.status === 'finished') {
        if (event.data.media) {
          const updatedMediaItem = event.data.media

          // Update current media list
          const mediaList = this.$utils.clone(this.mediaList)
          mediaList.itemsToShow = this.$utils.updateItemFromList(mediaList.itemsToShow, updatedMediaItem, 'resourceId') // Update media items in Media List
          mediaList.batchHistory.forEach((mediaListByBatch) => { // Update Media List by batch
            mediaListByBatch = this.$utils.updateItemFromList(mediaListByBatch, updatedMediaItem, 'resourceId')
          })
          this.setMediaList(mediaList)
        }
      }
    },
    postMessageToSVG (params) {
      const selectedSchedulePreviewEl = $(`#mediaProjectFile_${params.resourceId}`)

      if (selectedSchedulePreviewEl.length) {
        const msg = params.message ? params.message : {}
        selectedSchedulePreviewEl[0].contentWindow.postMessage(msg, '*')
      }
    },
    addMessageListener () {
      if (!this.handleSVGMessageEventListenerFunction) {
        this.handleSVGMessageEventListenerFunction = this.handleSVGMessage.bind(this)
        window.addEventListener('message', this.handleSVGMessageEventListenerFunction)
      }
    },
    removeMessageListener () {
      if (this.handleSVGMessageEventListenerFunction) {
        window.removeEventListener('message', this.handleSVGMessageEventListenerFunction)
        this.handleSVGMessageEventListenerFunction = null
      }
    },
    onEnter (event) {
      if (event.target.id === 'media-list-search') {
        this.mediaFilterTextInputConfirm()
      }
    }
  },
  beforeUnmount () {
    this.$dataStore.setStore({ selectedPopIdsFromSlider: { mediaListInModal: [] } })
    this.removeMessageListener()
  },
  mounted () {
    this.addMessageListener()
    this.handleMediaListVisible(this.isMediaListVisibleProp)
    this.isChromeBrowser = this.$utils.getBrowser() === 'Chrome'
    this.isIEBrowser = this.$utils.getBrowser() === 'IE'

    $(window).on('resize', () => { this.$utils.updatePageComponentStyle({ name: 'mediaListInModal' }) })

    // Fetch media list on scroll
    this.$utils.infiniteScroll('mediaListItemContainer', () => {
      if (this.mediaList.nextFetch.moreItems) {
        this.getMediaList({
          resetMediaList: false,
          additionalParams: {
            exclusiveStartResourceId: this.mediaList.nextFetch.exclusiveStartResourceId
          }
        })
      }
    })

    // Check is auth
    this.isAuthenticated({
      callback: () => {
        this.setDefaultData()
        this.getMediaList({
          callback: () => { this.$utils.mainLoader(false) },
          mounted: true
        })
      }
    })
  }
}
